/// <reference path="../typings/index.d.ts" />
/// <reference path="FormStep.d.ts" />

namespace App {
    export class FormStep implements IFormStep {
        private form: any;

        public inicializarCampo(elForm: any, callbackSubmit: any = null, callback: any = null, labels: any = { previous: 'Previous', next: 'Next', finish: 'Finish', current: '' }): void {
            this.form = elForm;
            this.form.steps({
                headerTag: "h3",
                bodyTag: "fieldset",
                transitionEffect: "fade",
                labels: labels,
                titleTemplate: '<h3 class="title">#title#</h3>',
                onFinished: function(event: any, currentIndex: number) {
                    console.log('Sumited');
                    callbackSubmit($(this));
                }
            });
            $(".toggle-password").on('click', function() {
                $(this).toggleClass("zmdi-eye zmdi-eye-off");
                var input = $($(this).attr("toggle"));
                if (input.attr("type") == "password") {
                    input.attr("type", "text");
                } else {
                    input.attr("type", "password");
                }
            });

            if (callback) {
                setTimeout(() => {
                    callback();
                }, 4000);
            }
            console.log("seeeooo");
        }
    }
}
